module.exports = __webpack_public_path__ + "img/slogan.3eb423e6.png";